import React from 'react';
import AdminModal from './AdminModal';

function ConfirmDialog({ open, onClose, onConfirm, title, message, confirmText = 'Confirm', confirmVariant = 'primary', loading }) {
  return (
    <AdminModal
      open={open}
      onClose={onClose}
      title={title || 'Confirm Action'}
      width="440px"
      footer={
        <>
          <button className="admin-btn admin-btn--secondary" onClick={onClose} disabled={loading}>Cancel</button>
          <button className={`admin-btn admin-btn--${confirmVariant}`} onClick={onConfirm} disabled={loading}>
            {loading ? 'Processing...' : confirmText}
          </button>
        </>
      }
    >
      <p style={{ color: 'var(--admin-text-secondary)', fontSize: '14px', margin: 0, lineHeight: '1.5' }}>{message}</p>
    </AdminModal>
  );
}

export default ConfirmDialog;
